// modified Info from swagger-ui
// ref: https://github.com/swagger-api/swagger-ui/blob/4d9ec4fb0eaaddb7e1a8f4502e8e8577d40e46ec/src/core/components/info.jsx
import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@rbx/intl';
import { Grid, InlineCode, Typography } from '@rbx/ui';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import ImPropTypes from 'react-immutable-proptypes';
import { sanitizeUrl } from '../utils/coreUtils';
import { SwaggerComponentProps } from '../types/SwaggerComponentProps';
import { getDownloadSwaggerJsonUrl } from '../utils/linkUtils';

const DInfoBasePath: FunctionComponent<SwaggerComponentProps> = ({ host, basePath }) => {
  const { translate } = useTranslation();
  const fileUrl = getDownloadSwaggerJsonUrl(window.location.pathname);

  return (
    <Grid container rowGap={1.5}>
      <Grid item container XSmall={12} marginRight={3}>
        <Grid item XSmall={12} Medium={2}>
          <Typography variant='body1' color='secondary' component='div'>
            {translate('Label.BaseURL')}
          </Typography>
        </Grid>
        <Grid item XSmall={12} Medium={10}>
          <InlineCode>
            {host}
            {basePath}
          </InlineCode>
        </Grid>
      </Grid>
      {fileUrl && (
        <Grid item container XSmall={12} marginRight={3}>
          <Grid item XSmall={12} Medium={2}>
            <Typography variant='body1' color='secondary' component='div'>
              JSON
            </Typography>
          </Grid>
          <Grid item XSmall={12} Medium={10}>
            <DynamicallyRouted.Link target='_blank' href={fileUrl}>
              {translate('Label.Download')}
            </DynamicallyRouted.Link>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export class DInfoUrl extends React.PureComponent<SwaggerComponentProps> {
  static propTypes = {
    url: PropTypes.string.isRequired,
  };

  render() {
    const { url } = this.props;

    return (
      <DynamicallyRouted.Link target='_blank' href={sanitizeUrl(url)}>
        <span className='url'> {url}</span>
      </DynamicallyRouted.Link>
    );
  }
}

class DInfo extends React.Component<SwaggerComponentProps> {
  static propTypes = {
    title: PropTypes.any,
    description: PropTypes.any,
    info: PropTypes.object,
    url: PropTypes.string,
    host: PropTypes.string,
    basePath: PropTypes.string,
    externalDocs: ImPropTypes.map,
    oas3selectors: PropTypes.func,
    selectedServer: PropTypes.string,
  };

  render() {
    const { info, host, basePath } = this.props;
    const description = info.get('description');

    return (
      <div className='info'>
        {description && <StandardMarkdown>{description}</StandardMarkdown>}

        <hgroup>
          {host || basePath ? <DInfoBasePath host={host} basePath={basePath} /> : null}
        </hgroup>
      </div>
    );
  }
}

export default DInfo;
